import {
  errorCatch,
  getTokenHeaders
} from '../helper';
import { getAxios } from '../axios';
import {
  ENDPOINT_APPOINTMENTS,
} from '../../config/endpoints';
import { Messages } from '../../config';

/**
 * Get list of appointments
 * @param {object} payload
 * @param {string} payload.notificationId
 * @param {object} payload.urlParams
 * @param {number} payload.urlParams.start
 * @param {number} payload.urlParams.end
 * @param {string} payload.urlParams.type
 * @param {string} payload.urlParams.page_context
 * @returns {Promise<T>}
 */
export function getAppointmentsByDate(payload) {
  return getAxios( false ).get(
    ENDPOINT_APPOINTMENTS,
    getTokenHeaders(payload.urlParams || null)
  )
    .then( response => {
      return response && response.data ? response : null
    } )
    .catch(
      e => {
        errorCatch( e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, payload.notificationId );

        return e.response;
      }
    );
}
